import React, {useState, useEffect} from 'react';
import styled, {css} from 'styled-components';
import {useHistory} from 'react-router-dom';
import {Body2} from '@bootcamp/web/src/components/Typography';

import {LoadingSpinner} from '@bootcamp/web/src/components/Branding';
import {useTable, usePagination, useSortBy} from 'react-table';
import {BareSelect} from '@bootcamp/web/src/bootcamps/components/MasteryReview/Select';

import {useUserDataContext} from '@bootcamp/web/src/contexts/UserData';

import {TableOverflowInnerWrapper, TableOverflowOuterWrapper} from '@bootcamp/web/src/bootcamps/components/Performance/shared';
import {ChevronLeft} from '@styled-icons/fluentui-system-filled/ChevronLeft';
import {ChevronRight} from '@styled-icons/fluentui-system-filled/ChevronRight';
import CreateTestButton from '@bootcamp/web/src/bootcamps/pages/CreateTest/components/CreateTestButton';

import { AutoHeightParent } from '@bootcamp/web/src/components/AutoHeightParent';


const StyledAutoHeightParent = styled(AutoHeightParent)`
  margin-bottom: 0;
  ${({theme}) => theme.mediaQueries.tablet} {
    margin-bottom: 16px;
  }
`;

const TableStyles = styled.div`
  width: 100%;
  min-width: 960px;
  position: relative;

  table {
    background: white;
    table-layout: auto;
    overflow: hidden;
    border-radius: 8px;
    width: 100%;
    border-collapse: collapse;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.12);
    /* border-bottom-right-radius: ${({hasResults, loading}) => !hasResults && !loading ? '0px' : '8px'};
    border-bottom-left-radius: ${({hasResults, loading}) => !hasResults && !loading ? '0px' : '8px'}; */

    th {
      cursor: default;
      background: #FAFAFA;

      &:first-child {
        font-weight: 700;
        color: ${({theme}) => theme.colors.typographyPalette.secondary};
        text-align: left;
        font-size: 16px;
        padding-left: 24px;
      }

      font: bold 16px 'proxima-nova', sans-serif;
      text-shadow: none;
      border-width: 0;
      padding: 0 16px;
      text-align: left;
      border-bottom: 1px solid #EDEDF0;
      font-weight: 600;
      height: 48px;
    }
    tr {
      cursor: pointer;
      max-height: 48px;
      &:last-child {
        td {
          border-bottom: none;
        }
      }
      &:hover {
        background-color: ${({theme}) => theme.colors.neutralsPalette.offWhite};
      }
    }
    td {
      min-width: 50px;
      font-size: 16px;

      &:first-child {
        padding-left: 24px;
        color: ${({theme}) => theme.colors.typographyPalette.secondary};
      }
      &:last-child {
        text-align: right;
        padding-right: 24px;
      }
      height: 48px;
      padding: 0 16px;
      vertical-align: middle;
      font: 400 16px 'proxima-nova', sans-serif;
      text-align: left;
      border-bottom: 1px solid ${({theme}) => theme.colors.neutralsPalette.light};
      position: relative;
      .editButton {
        position: absolute;
        margin: auto 8px;
        display: none;
      }
      &:hover {
        .editButton {
          display: inline;
        }
      }
    }
  }

  ${({theme}) => theme.mediaQueries.tablet} {
    ${({hasResults}) => !hasResults && css`
      min-width: auto;
      overflow: hidden;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    `}
  }
`;

const LoadingSpinnerContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px;
`;
const DataLoadingSpinner = (
  <LoadingSpinnerContainer>
    <LoadingSpinner color={'white'} size={24}/>
  </LoadingSpinnerContainer>
)

const ResultsMessage = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  border-radius: 8px;
  padding-top: 48px;
  `;

const ResultMessageWrapper = styled.div`
  background: rgba(255, 255, 255, 0.50);
  border-radius: 8px;
  backdrop-filter: blur(4px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const ResultMessageLabel = styled(Body2)`
  text-align: center;
  font-weight: 400;
  color: rgb(47, 48, 55);
`;

const TableWrapper = styled.div`
`;

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: white;

  button {
    height: 42px;
    width: 42px;
    border-radius: 100%;
    border: none;
    background: ${({theme}) => theme.overlays.opacity.light._100};
    color: white;
    cursor: pointer;
    margin-right: 8px;

    &:hover {
      background: ${({theme}) => theme.overlays.opacity.light._200};
    }
    &:disabled {
      cursor: not-allowed;
      border: none;
      background: ${({theme}) => theme.overlays.opacity.light._50};
      color: ${({theme}) => theme.overlays.opacity.light._400};
      &:hover {
        background: ${({theme}) => theme.overlays.opacity.light._50};
      }
    }
  }
  span {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    padding: 16px;
  }
  input {
    width: 80px;
    text-align: center;
    border: 1px solid ${({theme}) => theme.overlays.opacity.light._50};
    background: ${({theme}) => theme.overlays.opacity.light._50};
    font-family: 'proxima-nova';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: white;
    height: 40px;
    border-radius: 8px;
    margin-left: ${({theme}) => theme.layouts.spacing.m};
    ::placeholder {
      color: ${({theme}) => theme.overlays.opacity.light._400};
    }
  }
`;
const StyledCreateTestButton = styled(CreateTestButton)`
  margin: 0 auto;
`;

const StyledSelect= styled(BareSelect)`
  margin-left: 8px;
  select {
    padding: 12px;
    margin-right: 28px;
  }
`;
const LoadingRow = styled.tr`
  ${({theme}) => theme.animation.loadingBackground({loading: true, lightMode: true})};
`;


export const Table = ({columns, pageCount, data, hasResults, loading, currentPage, onNextPage, onPreviousPage, onPageSize, className}) => {
  const [tableHeight, setTableHeight] = useState();
  const {bootcamp} = useUserDataContext();
  const tableWrapperRef = React.useRef(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    // pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, sortBy: [{id: '#', desc: false}], hiddenColumns: document.documentElement.clientWidth <= 425 ? ['Date Taken', 'Settings', 'Type', 'Subjects', 'Questions'] : [] },
      disableSortRemove: true,
      manualPagination: true,
      pageCount,
      autoResetPage: false
    },
    useSortBy,
    usePagination
  );

  function handleNextPage() {
    nextPage();
    typeof onPreviousPage === 'function' && onNextPage();
  }

  function handlePreviousPage() {
    previousPage();
    typeof onNextPage === 'function' && onPreviousPage();
  }

  function handlePageSize(pageSize) {
    setPageSize(pageSize);
    setTableHeight(null);
    typeof onPageSize === 'function' && onPageSize(pageSize);
  }

  const {push} = useHistory();
  const paginationConfig = [
    {name: 'Show 10', value: 10},
    {name: 'Show 20', value: 20, disabled: (data?.length * pageCount) < 20},
    {name: 'Show 30', value: 30, disabled: (data?.length * pageCount) < 30},
    {name: 'Show 40', value: 40, disabled: (data?.length * pageCount) < 40},
    {name: 'Show 50', value: 50, disabled: (data?.length * pageCount) < 50},
  ];

  const pagination = (
    <PaginationWrapper>
      <span>
        Page {currentPage.pageIndex + 1} of {pageOptions.length}
      </span>
      <button onClick={() => handlePreviousPage()} disabled={!canPreviousPage || loading}>
        <ChevronLeft size={20} color="white" />
      </button>
      <button onClick={() => handleNextPage()} disabled={!canNextPage || loading}>
        <ChevronRight size={20} color="white" />
      </button>
      {
        <StyledSelect
          value={pageSize}
          config={paginationConfig}
          onChange={handlePageSize}
          loading={loading}
        >
          {paginationConfig.map(({value: pageSize, disabled}) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </StyledSelect>
      }
    </PaginationWrapper>
  );

  const noResults = (
    <ResultsMessage>
      <ResultMessageWrapper>
        {['dat', 'oat'].includes(bootcamp)
          ? <ResultMessageLabel style={{marginBottom: '16px'}}>Tests you complete will appear here for you to review.</ResultMessageLabel>
          : <>
            <ResultMessageLabel style={{marginBottom: '16px'}}>Tests you end or pause will appear here for you to review. Try creating a test.</ResultMessageLabel>
            <StyledCreateTestButton/>
          </>
        }
      </ResultMessageWrapper>
    </ResultsMessage>
  );

  useEffect(() => {
    if (tableWrapperRef.current && !loading) {
      setTableHeight(0);
      const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          const tableElement = entry.target.querySelector('table');
          if (tableElement) {
            const { height} = tableElement.getBoundingClientRect();
            setTableHeight(height);
          }
        }
      });

      observer.observe(tableWrapperRef.current);

      return () => {
        observer.disconnect();
      };
    }
  }
  , [tableWrapperRef.current, pageIndex, loading]);


  return (
    <TableWrapper className={className}>
      <StyledAutoHeightParent childRef={tableWrapperRef}>
        <TableOverflowOuterWrapper parentHasPadding>
          <TableOverflowInnerWrapper ref={tableWrapperRef} parentHasPadding>
            <TableStyles hasResults={hasResults} loading={loading}>
              <table {...getTableProps()} style={{height: tableHeight}}>
                <thead>
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(column => (
                        <th {...column.getHeaderProps(column.getSortByToggleProps())} style={column?.meta?.style}>
                          {column.render('Header')}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {loading
                    ? Array.from({ length: pageSize }, (_, i) => (
                      <LoadingRow key={i}>
                        {Array.from({ length: columns.length }, (_, i) => (
                          <td key={i} />
                        ))}
                      </LoadingRow>
                    ))
                    : page.map((row, i) => {
                        prepareRow(row)

                        // data passed from row
                        const {id: progressId, testId, route} = row?.original || {};

                        // data passed from data prop
                        const {config, submitted} = row?.original?.testData|| {};
                        const routeWithBootcamp = `/${bootcamp}${route}`;

                        const pushProps = ['dat', 'oat'].includes(bootcamp)
                          ? {pathname: `/${bootcamp}${route}/review`, search: `?id=${encodeURIComponent(testId)}&testProgressId=${encodeURIComponent(progressId)}&testRoute=${encodeURIComponent(routeWithBootcamp)}`}
                          : {pathname: submitted ? `/${bootcamp}/previous-tests/review` : `/${bootcamp}/custom-test`, search: `?key=${encodeURIComponent(config?.testStorageKey)}` }

                        return (
                          <tr onClick={() => push(pushProps)} {...row.getRowProps()}>
                            {row.cells.map(cell => {
                              return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            })}
                          </tr>
                        )
                    })}
                </tbody>
              </table>
              {!loading && !hasResults && noResults}
            </TableStyles>
          </TableOverflowInnerWrapper>
        </TableOverflowOuterWrapper>
      </StyledAutoHeightParent>
      {hasResults && pagination}
    </TableWrapper>
  );
}

export {TableStyles};
export default Table;


// const Table = ({columns, data, loading, pageCount, currentPage, onPreviousPage, onNextPage, onPageSize}) => {
//   const {bootcamp} = useUserDataContext();
//   const tableRef = useRef(null);
//   const [height, setHeight] = useState(0);

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     page,
//     canPreviousPage,
//     canNextPage,
//     pageOptions,
//     // pageCount,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     state: { pageIndex, pageSize },
//   } = useTable(
//     {
//       columns,
//       data,
//       initialState: { pageIndex: currentPage.pageIndex, sortBy: [{id: 'Date Taken', desc: true}] },
//       disableSortRemove: true,
//       pageCount,
//       manualPagination: true,
//     },
//     useSortBy,
//     usePagination
//   );

//   const {push} = useHistory();

//   function handlePreviousPage() {
//     previousPage();
//     onPreviousPage();
//   }

//   function handleNextPage() {
//     nextPage();
//     onNextPage();
//   }

//   const hasResults = data.length > 0;

//   useEffect(() => {
//     if (!tableRef?.current || loading) return;

//     setHeight(tableRef.current.clientHeight);

//   }, [tableRef?.current?.clientHeight, loading]);

//   useEffect(() => {
//     resetScrollPosition();
//   }, [pageIndex, pageSize]);

//   return (
//     <TableWrapper>
//       <TableStyles style={{height: loading ? Math.min(height, 550) : 'auto'}}>
//         <table {...getTableProps()} ref={tableRef} style={{height: loading ? Math.min(height, 550) : 'auto'}}>
//           <thead>
//             {headerGroups.map(headerGroup => (
//               <tr {...headerGroup.getHeaderGroupProps()}>
//                 {headerGroup.headers.map(column => (
//                   <th {...column.getHeaderProps(column.getSortByToggleProps())}>
//                     {column.render('Header')}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>
//           <tbody {...getTableBodyProps()}>
//             {page.map((row, i) => {
//               const {id: progressId, testId, route} = row.original;
//               const routeWithBootcamp = `/${bootcamp}${route}`;

//               prepareRow(row);

//               return (
//                 <tr {...row.getRowProps()} onClick={() => push({pathname: `/${bootcamp}${route}/review`, search: `?id=${encodeURIComponent(testId)}&testProgressId=${encodeURIComponent(progressId)}&testRoute=${encodeURIComponent(routeWithBootcamp)}`})}>
//                   {row.cells.map(cell => {
//                     return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
//                   })}
//                 </tr>
//               )
//             })}
//           </tbody>
//         </table>
//         {!hasResults && !loading
//           ? <ResultsMessage>Nothing to see here yet!</ResultsMessage>
//           : null
//         }
//         <LoadingSpinnerContainer visible={loading}>
//           <LoadingOverlay visible={loading}/>
//           <LoadingSpinner color={'royal'} size={24} />
//         </LoadingSpinnerContainer>
//       </TableStyles>
//       <PaginationWrapper>
//         <span>
//           Page&nbsp;
//           <strong>
//             {pageIndex + 1} of {pageOptions.length}
//           </strong>
//         </span>
//         <button onClick={handlePreviousPage} disabled={!canPreviousPage || loading}>
//           <ChevronLeft size={20} color="white" />
//         </button>
//         <button onClick={handleNextPage} disabled={!canNextPage || loading}>
//           <ChevronRight size={20} color="white" />
//         </button>
//         <StyledSelect
//           value={pageSize}
//           loading={loading}
//           config={[
//             { name: 'Show 10', value: 10 },
//             { name: 'Show 20', value: 20 },
//             { name: 'Show 30', value: 30 },
//             { name: 'Show 40', value: 40 },
//             { name: 'Show 50', value: 50 },
//           ]}
//           onChange={async value => {
//             await onPageSize(value);
//             setPageSize(value);
//           }}
//         >
//           {[10, 20, 30, 40, 50].map(pageSize => (
//             <option key={pageSize} value={pageSize}>
//               Show {pageSize}
//             </option>
//           ))}
//         </StyledSelect>
//       </PaginationWrapper>
//     </TableWrapper>
//   );
// }